import { render, staticRenderFns } from "./OrderFilters.vue?vue&type=template&id=16f3c602&scoped=true&"
import script from "./OrderFilters.vue?vue&type=script&lang=js&"
export * from "./OrderFilters.vue?vue&type=script&lang=js&"
import style0 from "./OrderFilters.vue?vue&type=style&index=0&id=16f3c602&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f3c602",
  null
  
)

/* custom blocks */
import block0 from "./OrderFilters.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports